<script setup lang="ts">
import { ref, watch } from 'vue';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown } from 'lucide-vue-next';

const props = defineProps<{
  title: string;
  first?: boolean;
  forceExpanded?: boolean;
}>();

const open = ref(true);

watch(
  () => props.forceExpanded,
  val => {
    if (val) open.value = true;
  }
);
</script>

<template>
  <Collapsible v-model:open="open" :class="{ 'tw-mt-7': !first }">
    <CollapsibleTrigger
      class="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-border-b tw-border-surface-200 tw-pb-2.5 tw-mb-4 tw-font-heading tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wide tw-text-secondary-700 tw-transition-colors hover:tw-text-secondary-900 dark:tw-border-neutral-800 dark:tw-text-neutral-300 dark:hover:tw-text-neutral-100"
    >
      <span>{{ title }}</span>
      <ChevronDown
        class="tw-h-4 tw-w-4 tw-shrink-0 tw-text-surface-400 tw-transition-transform tw-duration-200"
        :class="{ 'tw-rotate-180': !open }"
      />
    </CollapsibleTrigger>
    <CollapsibleContent>
      <div class="tw-px-1">
        <slot />
      </div>
    </CollapsibleContent>
  </Collapsible>
</template>
